// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"index_messageBox_fmFG5","messageBoxButton":"index_messageBoxButton_2q2Vb"};